import { css } from 'styled-components'

export const Noto_b_size = (size: number) => css`
  font-size: ${size}px;
  font-weight: 700;
  line-height: 1.2;
  font-family: 'Noto Sans KR', sans-serif;
`

export const Noto_r_size = (size: number) => css`
  font-size: ${size}px;
  font-weight: 400;
  line-height: 1.2;
  font-family: 'Noto Sans KR', sans-serif;
`
